import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × A.P.C.: Parisian restraint meets geometric discipline
// Denim grids, monochrome blocks, clean serif typography
export function VasarelyApcMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="apc-denim" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#304E6C" />
          <stop offset="50%" stopColor="#4A6B8A" />
          <stop offset="100%" stopColor="#2C4A63" />
        </linearGradient>
        <pattern id="apc-weave" x="0" y="0" width="4" height="4" patternUnits="userSpaceOnUse">
          <rect x="0" y="0" width="2" height="2" fill="#3A5A75" />
          <rect x="2" y="2" width="2" height="2" fill="#3A5A75" />
        </pattern>
      </defs>

      {/* Clean minimal background */}
      <rect x="0" y="0" width="794" height="1123" fill="#F5F5F0" />

      <g transform="translate(397 540)">
        {/* Monochrome blocks */}
        {[
          { x: -200, y: -250, w: 180, h: 180, fill: "#2C4A63" },
          { x: 20, y: -250, w: 180, h: 180, fill: "#FFFFFF" },
          { x: -200, y: -50, w: 180, h: 180, fill: "#FFFFFF" },
          { x: 20, y: -50, w: 180, h: 180, fill: "#304E6C" },
          { x: -200, y: 150, w: 180, h: 180, fill: "#E8E8E0" },
          { x: 20, y: 150, w: 180, h: 180, fill: "#2C4A63" },
        ].map((block, i) => (
          <rect
            key={i}
            x={block.x}
            y={block.y}
            width={block.w}
            height={block.h}
            fill={block.fill}
            stroke="#D0D0C8"
            strokeWidth="1"
          />
        ))}

        {/* Denim grid overlay */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 10 }).map((_, j) => {
            const x = (i - 7.5) * 50;
            const y = (j - 4.5) * 100;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 24}
                y={y - 48}
                width="48"
                height="96"
                fill="url(#apc-weave)"
                opacity="0.1"
              />
            );
          })
        )}

        {/* Clean serif typography structure */}
        {Array.from({ length: 5 }).map((_, i) => {
          const y = -200 + i * 100;
          return (
            <line
              key={i}
              x1="-250"
              y1={y}
              x2="250"
              y2={y}
              stroke="#4A6B8A"
              strokeWidth="1"
              opacity="0.3"
            />
          );
        })}

        {/* Normcore precision grid */}
        <rect x="-220" y="-280" width="440" height="560" fill="none" stroke="#2C4A63" strokeWidth="2" />
        <rect x="-210" y="-270" width="420" height="540" fill="none" stroke="#2C4A63" strokeWidth="1" opacity="0.5" />

        {/* Central denim square */}
        <rect x="-80" y="-80" width="160" height="160" fill="url(#apc-denim)" />
        <rect x="-80" y="-80" width="160" height="160" fill="url(#apc-weave)" opacity="0.3" />
        <rect x="-80" y="-80" width="160" height="160" fill="none" stroke="#FFFFFF" strokeWidth="1" />
      </g>

      {/* Clean typography */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="10" fill="#2C4A63" letterSpacing="2">
        NORMCORE PRECISION
      </text>
    </g>
  );
}
